import React from 'react';
import { TextProps, TextComponent } from './interface';
import { BOLD_WEIGHT, TEXT_VALUES } from './constants';
import { InternalTypography } from '../InternalTypography';
import { getTestId } from '@src/utils/testIds';

const Text: TextComponent = (props: TextProps) => {
  const { color, size, bold, italic, strikethrough, children, textAlign } = props;
  const { fontSize, fontWeight, lineHeight, letterSpacing } = TEXT_VALUES[size];

  return (
    <InternalTypography
      color={color}
      italic={italic}
      strikethrough={strikethrough}
      fontSize={fontSize}
      fontWeight={bold ? BOLD_WEIGHT : fontWeight}
      lineHeight={lineHeight}
      letterSpacing={letterSpacing}
      textAlign={textAlign}
      $web={{ component: 'p' }}
      testId={getTestId(props)}
    >
      {children}
    </InternalTypography>
  );
};

export { Text };
